import React, { useMemo } from "react";

import {
  AppShell,
  createTheme,
  MantineProvider,
  Modal,
  rem,
} from "@mantine/core";

import {
  createCookieColorSchemeManager,
  getColorSchemeFromCookies,
} from "./color-scheme";

export const theme = createTheme({
  colors: {
    brandPrimaryDark: [
      "#f5f2f8",
      "#e7e2ea",
      "#cdc1d5",
      "#b39ec0",
      "#9d80af",
      "#8f6ea5",
      "#8964a0",
      "#76548c",
      "#694a7e",
      "#5c3f6f",
    ],

    brandPrimaryLight: [
      "#f6f0fa",
      "#e8ddee",
      "#cfb8df",
      "#b68fcf",
      "#a16ec3",
      "#9458bb",
      "#8e4db8",
      "#7b3fa2",
      "#6e3791",
      "#5f2e80",
    ],
  },

  autoContrast: true,
  primaryColor: "brandPrimaryLight",

  shadows: {
    md: "1px 1px 3px rgba(0, 0, 0, .25)",
    xl: "5px 5px 3px rgba(0, 0, 0, .25)",
  },

  fontFamily: "Montserrat, sans-serif",

  headings: {
    sizes: {
      h1: { fontSize: rem(36) },
    },
  },
  components: {
    Modal: Modal.extend({
      styles: {
        content: {
          zIndex: 1000,
        },
      },
    }),
    AppShell: AppShell.extend({
      styles: {
        header: {
          background: "var(--mantine-color-brandPrimaryDark-9)",
          border: "none",
        },
        navbar: {
          background: "linear-gradient(180deg, #392745 0%, #110718 100%)",
          color: "var(--mantine-color-white)",
        },
        main: {
          paddingRight: 0,
          paddingBottom: 0,
          display: "flex",
          flexDirection: "column",
        },
      },
    }),
  },
});

interface MantineProps {
  children: React.ReactNode;
  requestHeaders?: { [key: string]: string };
}

const SimsiMantineProvider: React.FC<MantineProps> = ({
  children,
  requestHeaders,
}) => {
  const cookieHeader = requestHeaders?.cookie || requestHeaders?.Cookie;
  const colorSchemeManager = useMemo(
    () => createCookieColorSchemeManager(cookieHeader),
    [cookieHeader],
  );
  const initialColorScheme = getColorSchemeFromCookies(cookieHeader);

  return (
    <MantineProvider
      theme={theme}
      defaultColorScheme={initialColorScheme}
      colorSchemeManager={colorSchemeManager}
    >
      {children}
    </MantineProvider>
  );
};

export default SimsiMantineProvider;
